/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Whether plaintext was revealed or the MCP finding evidence is unavailable or expired.
 */
export const RiskUnmaskResultResultRevealState = {
  Available: "available",
  EvidenceNotStored: "evidence_not_stored",
} as const;
/**
 * Whether plaintext was revealed or the MCP finding evidence is unavailable or expired.
 */
export type RiskUnmaskResultResultRevealState = ClosedEnum<
  typeof RiskUnmaskResultResultRevealState
>;

export type RiskUnmaskResultResult = {
  /**
   * The risk result ID.
   */
  id: string;
  /**
   * The plaintext matched secret or sensitive data for this result. Empty string when the finding has no top-level match (e.g. a spans-only finding).
   */
  match: string;
  /**
   * Whether plaintext was revealed or the MCP finding evidence is unavailable or expired.
   */
  revealState: RiskUnmaskResultResultRevealState;
};

/** @internal */
export const RiskUnmaskResultResultRevealState$inboundSchema: z.ZodMiniEnum<
  typeof RiskUnmaskResultResultRevealState
> = z.enum(RiskUnmaskResultResultRevealState);

/** @internal */
export const RiskUnmaskResultResult$inboundSchema: z.ZodMiniType<
  RiskUnmaskResultResult,
  unknown
> = z.pipe(
  z.object({
    id: z.string(),
    match: z.string(),
    reveal_state: RiskUnmaskResultResultRevealState$inboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      "reveal_state": "revealState",
    });
  }),
);

export function riskUnmaskResultResultFromJSON(
  jsonString: string,
): SafeParseResult<RiskUnmaskResultResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => RiskUnmaskResultResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RiskUnmaskResultResult' from JSON`,
  );
}
